module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/db93767599eba837a46871720a47d148.png";